import Webshop from '@wwdev/webshop';
import Checkout from "./Checkout";
import Bindings from "@wwdev/webshop/bindings";
import Variants from "@wwdev/webshop/variants";
import './product';

Webshop.basket.init();
Webshop.shipping.init();

Checkout.init();
Bindings.init();
Variants.init();
